
let topdeskLogo = "/src/assets/logo/topdesk_small.png";
let info = {
  name: "Benjamin da Silva Moreira",
  logo_name: "Benjamin da Silva Moreira",
  flat_picture: require("./src/assets/benjamin_wappen.jpg"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false
    }
  },
  description:
    "<br><b>Ich kandidiere für die <a style=\"color:orange\" href=\"http://fwg-olsbruecken.de\" target=\"_blank\">FWG</a> am 09.06.2024 zum Bürgermeister.</b><br><br>Als gebürtigem Olsbrücker liegt mir der Ort und seine Bürger am Herzen. Ich vertrete <b><u>Ihre</u> Interessen</b>, <b><u>nicht</u></b> Parteieninteressen - geleitet von <b>gesundem Menschenverstand</b>, <b><u>nicht</u></b> Parteienideologie.</b><br><br>Den <b>Jugendtreff</b> möchte ich wiedereröffnen, um endlich wieder allen Generationen etwas bieten zu können.<br><br><b>Maßlose Steuererhöhungen</b>, wie Sie unsere SPD-geführte Landesregierung (Ampel-Koalition) den Kommunen abverlangen will, <b>lehne ich ab</b> und werde diesen <b>entgegentreten</b>.<br><br> Nach <b>jahrzehnterlanger Unterfinanzierung</b> durch das Land müsste die kommunale Entschuldung ohne Bedingungen erfolgen, stattdessen sollen wir <b>den Bürgern tief in die Taschen greifen</b>, um kurzfristig einen ausgeglichen Haushalt vorzulegen. <br><br><b>Ich und die <font color='orange'>FWG</font>-Fraktion machen da nicht mit!</b>",
  links: {
    linkedin: "https://www.linkedin.com/in/benjamin-da-silva-moreira-9460555a",
    facebook: "https://www.facebook.com/benjamin.gehm.3/",
    github: "",
    behance: "",
    resume: "",
  },
  steckbrief: [
    { 
      icon: "<i class='fas fa-baby icon'>",
      title: "09.08.1983 in Kaiserslautern",
      subtitle: "Geburtsname: Gehm"            
    },    
    {
      icon: "<i class='fa-solid fa-ring icon'></i>",
      title: "Verheiratet seit 2013",
      subtitle: "mit Sofia da Silva Moreira"            
    },
    {
      icon: "<i class='fa-solid fa-children fa-flip-horizontal icon'></i>",
      title: "2 Kinder",
      subtitle: "Diego (7) & Celena (3)"            
    },
    {
      icon: "<i class='fa-solid fa-user-tie icon'></i>",
      title: "Teamleiter Technische Beratung"           
    },
    {
      icon: "<i class='fa-solid fa-futbol icon'></i>",
      title: "Aktiver Fußballer seit dem 7. Lebensjahr",
      subtitle: "TuS Olsbrücken, AH SG Olsbrücken / Schallodenbach"            
    },
    {
      icon: "<i class='fa-solid fa-hammer icon'></i>",
      title: "Häuslebauer und Heimwerker",
      subtitle: "Es gibt immer was zu tun"            
    },
    {
      icon: "<i class='fa-solid fa-computer icon'></i>",
      title: "Technikbegeistert",
      subtitle: "vom Lötkolben bis Programmierung"            
    },
    {
      icon: "<i class='fa-solid fa-guitar icon'></i>",
      title: "Musikalisch",
      subtitle: "früher Gitarrist in der Band \"Exxes\", heute gelegentlich am Lagerfeuer", 
    }
  ],
  experience: [
    { 
      icon: "<i class='fa-solid fa-landmark icon'></i>",
      title: "Gemeinderatsmitglied in Olsbrücken",
      subtitle: "seit der Kommunalwahl 2019", 
      skills: ["Vorsitzender Rechnungsprüfungsausschuss", "Mitglied Kindergartenzweckverband", "Stv. Beigeordneter Haupt- und Finanzausschuss"]
    },
    {
      icon: "<i class='fa-solid fa-person-rays icon'></i>",
      title: "Bürgermeisterkandidat",
      subtitle: "Kommunalwahl am 09.06.2024",       
      skills: ["Keine maßlosen Steuererhöhungen", "Jugendtreff wiedereröffnen","Gesunder Menschenverstand", "Keine Parteienideologie", "Kein Fraktionszwang"]
    },
    {
      icon: "<i class='fa-solid fa-check-to-slot icon'></i>",
      title: "FWG Listenplatz 9",
      subtitle: "Wahl zum Verbandsgemeinderat 2024", 
      skills: ["Interessensvertretung für Olsbrücken in der VG"]
    },
   
   
  ],
  skills: [
    {
      title: "Solide Finanzen",
      info: ["Keine maßlosen Steuererhöhungen"],
      icon: "fa-solid fa-piggy-bank"
    },
    {
      title: "Jugendtreff wiedereröffnen",
      info: ["Angebote für alle Generationen"],
      icon: "fa-solid fa-children"
    },
    {
      title: "Gesunder Menschenverstand",
      info: ["Keine Parteienideologie"],
      icon: "fa-solid fa-lightbulb"
    },
    
  ],
  portfolio_design: [
    {
      name: "Keep it Green",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/Keep it green/cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/Keep it green/show.png"),
          title: "show"
        },
      ],
      technologies: ["Figma", "Photoshop"],
      category: "Visual Design",
      github: "",
      date: "Jan, 2022",
      visit: "",
      description:
        ""
    },
    {
      name: "Digital agency website",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/digital agency/behance cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/digital agency/1. start.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/2. about.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/3. Our services.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/4. latest project.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/5. Contact us.png"),
          title: "App Elements"
        },
      ],
      technologies: ["Figma", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Dec, 2021",
      visit: "",
      description:
        ""
    },
    {
      name: "Credit card design",
      title: "Illustration",
      pictures: [
        {
          img: require("./src/assets/designs/credit/behance cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/credit/degisning.png"),
          title: "Degisning"
        },
        {
          img: require("./src/assets/designs/credit/Dual tune.png"),
          title: "Dual tune"
        },
        {
          img: require("./src/assets/designs/credit/Glassmorphism.png"),
          title: "Glassmorphism"
        },
        {
          img: require("./src/assets/designs/credit/Gradiant.png"),
          title: "Gradiant"
        },
        {
          img: require("./src/assets/designs/credit/Monochrome.png"),
          title: "Monochrome"
        },
        {
          img: require("./src/assets/designs/credit/Neumorphism.png"),
          title: "Neumorphism"
        },
      ],
      technologies: ["Figma", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Dec, 2021",
      visit: "",
      description:
        ""
    },
    {
      name: "BOOKSI",
      title: "E-Book library - UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/booksi/behance cover.png"),
          title: "Cover"
        },
        {
          img: require("./src/assets/designs/booksi/behance board.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/booksi/login.png"),
          title: "login"
        },
        {
          img: require("./src/assets/designs/booksi/register.png"),
          title: "register"
        },
        {
          img: require("./src/assets/designs/booksi/home page.png"),
          title: "homepage"
        },
        {
          img: require("./src/assets/designs/booksi/For you.png"),
          title: "just for you"
        }
      ],
      technologies: ["Figma", "Photoshop"],
      category: "Visual Design",
      github: "",
      date: "Nov, 2021",
      visit: "",
      description:
        " BOOKSI is Ebook android app for easy read books."
    },
    {
      name: "Quiet Weather",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/weather/Wooden Hand iPhone 12 Pro.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/weather/artboard.png"),
          title: "show"
        },
        {
          img: require("./src/assets/designs/weather/weather app react native.png"),
          title: "components"
        },
      ],
      technologies: ["Figma", "Illustration"],
      category: "Visual Design",
      github: "",
      date: "Nov, 2021",
      visit: "",
      description:
        "Quiet Weather is a react native app by openweathermap api, i designed the ui/ux and coding it in react native, enjoy it!"
    },
    {
      name: "Pill Reminder",
      title: "Pill Reminder - Mockup Design",
      pictures: [
        {
          img: require("./src/assets/designs/pill reminder/Web 1.png"),
          title: "Moodboard"
        },
        {
          img: require("./src/assets/designs/pill reminder/1.png"),
          title: "Mockups 1"
        },
        {
          img: require("./src/assets/designs/pill reminder/2.png"),
          title: "Mockups 2"
        }
      ],
      technologies: ["XD", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Apr, 2021",
      visit: "",
      description:
        "pill reminder app for nessecary drugs for the day."
    },
  ],
  portfolio: [
    {
      name: "Diary App",
      pictures: [
        {
          img: require("./src/assets/portfolio/diary/1.png")
        },
        {
          img: require("./src/assets/portfolio/diary/2.png")
        },
        {
          img: require("./src/assets/portfolio/diary/3.png")
        },
      ],
      technologies: ["react", "scss", "local storage"],
      category: "Web App",
      date: "Aug, 2021 - 20 days",
      github:
        "https://github.com/mahy209/notes-react-app.git",
      visit: "https://github.com/mahy209/notes-react-app.git",
      description:
        " Diary react app with some new features: Dark mode, upload images, tags, filter search with title/content/tag "
    },
    {
      name: "Online Examination",
      pictures: [
        {
          img: require("./src/assets/portfolio/online examination/exam (1).png")
        },
        {
          img: require("./src/assets/portfolio/online examination/exam (2).png")
        },
        {
          img: require("./src/assets/portfolio/online examination/exam (3).png")
        },
        {
          img: require("./src/assets/portfolio/online examination/exam (4).png")
        },
        {
          img: require("./src/assets/portfolio/online examination/exam (5).png")
        }
      ],
      technologies: ["HTML", "CSS","JavaSript","JQuery", "PHP", "MySQL"],
      category: "Web App",
      date: "Apr, 2021 - May, 2021",
      github: "https://github.com/mahy209/online-examination.git",
      visit: "https://github.com/mahy209/online-examination.git",
      description:
        "Online Examination System Today Online Examination System has become a fast growing examination method because of its speed and accuracy. It is also needed less manpower to execute the examination. Almost all organizations now-a-days, are conducting their objective exams by online examination system, it saves students time in examinations. Organizations can also easily check the performance of the student that they give in an examination. As a result of this, organizations are releasing results in less time. It also helps the environment by saving paper. According to today’s requirement, online examination project in php is very useful to learn it. What is an online examination system? In an online examination system examine get their user id and password with his/her admit card. This id is already saved in the examination server. When examine login to the server he/she get his/her profile already register. On the certain time examine gets the message to start the examination. All answers given by examine are saved into the server with his/her profile information. Online examination system also allows to correct the answer if the examine needed to change any answer in the examination time duration, however, after the time duration any change will not allow. This also makes c checking the answer easy and error proof as computers are more accurate than man and provide fast results too. Php is a web base language so we can create an online examination system in PHP. Administrator of Online Examination has multiple features such as Add, Delete, Update Topics and Question. To Login as Admin put inside your browser."
    },
    {
      name: "MyFlix.com",
      pictures: [
        {
          img: require("./src/assets/portfolio/myflix.com/1.png")
        },
        {
          img: require("./src/assets/portfolio/myflix.com/2.png")
        },
        {
          img: require("./src/assets/portfolio/myflix.com/3.png")
        },
        {
          img: require("./src/assets/portfolio/myflix.com/4.png")
        },
      ],
      technologies: ["react", "css", "TMDB"],
      category: "Web App",
      date: "Aug, 2021 - 10 days",
      github:
        "https://github.com/mahy209/MyFlix-react-app.git",
      visit: "https://github.com/mahy209/MyFlix-react-app.git",
      description:
        " flix.com is a netflix clone using React JS and TMDB with courusal and search engine. "
    },
  ],
};

export default info;
